// The Ring the business is on (M3-20b): an Owner opts in to the alpha Ring, where new LAMP releases arrive just
// after LAMP's own business and before most others, or out again. A setting of the business, kept in the Audit Log,
// not a Tree Change. A business LAMP holds in its internal Ring is told so, and cannot change it.
import { useEffect, useState } from "react";
import { ApiError, type Api, type RingSetting as Ring } from "../api.js";
import { useWords } from "../i18n/words.js";

export function RingSetting({ api }: { api: Pick<Api, "ring" | "setAlpha"> }) {
  const w = useWords();
  const [ring, setRing] = useState<Ring>();
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState<string>();
  const [problem, setProblem] = useState<string>();

  useEffect(() => {
    let live = true;
    api.ring().then(
      (found) => live && setRing(found),
      () => live && setRing(undefined),
    );
    return () => {
      live = false;
    };
  }, [api]);

  if (!ring) return null;
  const choose = async (alpha: boolean) => {
    setBusy(true);
    setNotice(undefined);
    setProblem(undefined);
    try {
      setRing(await api.setAlpha(alpha));
      setNotice(w.ringSaved(alpha));
    } catch (error) {
      setProblem(
        error instanceof ApiError && error.problems.length > 0 ? error.problems.join("; ") : w.settingsUnreachable,
      );
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="section" aria-labelledby="ring-heading">
      <h2 id="ring-heading">{w.ringHeading}</h2>
      {ring.changeable ? (
        <>
          <label>
            <input
              type="checkbox"
              checked={ring.ring === "alpha"}
              disabled={busy}
              onChange={(event) => void choose(event.target.checked)}
            />{" "}
            {w.ringAlpha}
          </label>
          <p className="small muted">{w.ringAlphaHelp}</p>
        </>
      ) : (
        <p>{w.ringInternal}</p>
      )}
      {notice ? <p role="status">{notice}</p> : null}
      {problem ? (
        <p className="alert" role="alert">
          {problem}
        </p>
      ) : null}
    </section>
  );
}
